import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';

/**
 * The styled component for the Icon
 */
var StyledIcon = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > svg {\n    width: ", "px;\n    height: ", "px;\n    color: ", ";\n  }\n"], ["\n  > svg {\n    width: ", "px;\n    height: ", "px;\n    color: ", ";\n  }\n"])), function (_a) {
  var size = _a.size;
  return size;
}, function (_a) {
  var size = _a.size;
  return size;
}, function (_a) {
  var color = _a.color;
  return color;
});
/**
 * The Icon component
 *
 * @param {IconProps} props - The props for the Icon component.
 * @returns {JSX.Element} The Icon component.
 */
var Icon = function (_a) {
  var icon = _a.icon,
    size = _a.size,
    color = _a.color;
  return jsx(StyledIcon, {
    size: size,
    color: color,
    children: icon
  });
};
var templateObject_1;

export { Icon, StyledIcon };
//# sourceMappingURL=Icon.js.map
